<div class="container-fluid" *transloco="let t">
  <div class="container">
    <div class="row mt-3">
      <div class="col-lg-8">
        @if (name(); as name) {
          <h1 class="font-weight-bold mt-3 text-break">{{ name }}</h1>
          <p class="text-muted">{{ t('common.coming_soon') }}</p>
        }

        @if (!name() && isAnythingLoading()) {
          <h5 class="card-title placeholder-glow mt-3"><span class="placeholder col-6"></span></h5>
          <multisite-loader-globe-animation-detail [width]="100" [height]="100"></multisite-loader-globe-animation-detail>
        }

        @if (notFound()) {
          <alert [type]="'warning'" class="d-block mt-4">
            <p class="text-center my-4">{{ t('common.not_found') }}</p>
          </alert>
        }

        @if (failed()) {
          <alert [type]="'danger'" class="d-block mt-4">
            <p class="text-center my-4">{{ t('error.something_went_wrong') }}</p>
          </alert>
        }
      </div>
    </div>
  </div>
</div>
